var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.331 0C10.4463 0 0 10.2598 0 22.9144C0 34.3498 8.53067 43.8281 19.6863 45.5537V29.5396H13.7597V22.9144H19.6863V17.8658C19.6863 12.1183 23.17 8.94896 28.497 8.94896C31.0497 8.94896 33.7237 9.39583 33.7237 9.39583V15.031H30.7743C27.881 15.031 26.9757 16.8002 26.9757 18.6129V22.9098H33.4413L32.4077 29.535H26.9757V45.5492C38.1313 43.8327 46.662 34.3521 46.662 22.9144C46.662 10.2598 36.2157 0 23.331 0Z",
    fill: "#796F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5ff260ac64c7ea9a7c5968a5ae18d9ea.svg";
export { ForwardRef as ReactComponent };